import * as React from "react";
import { Modal as MantineModal } from "@mantine/core";
import styled, { css } from "styled-components";
import zIndices from "theme/z-indices";
const XLARGE_MODAL_WIDTH_PX = 1200;
const ModalOverlay = styled(MantineModal.Overlay)(
  ({ $isConfirmDialog }) => css`
    z-index: ${$isConfirmDialog ? zIndices.confirmModalOverlay : zIndices.modalOverlay};
  `
);
const ModalContent = styled(MantineModal.Content)(
  ({ $isConfirmDialog }) => css`
    z-index: ${$isConfirmDialog ? zIndices.confirmModalBody : zIndices.modalBody};
    border-radius: 10px;
  `
);
const StyledModalFooter = styled(MantineModal.Body)(
  ({ theme }) => css`
    position: sticky;
    bottom: 0;
    background-color: ${theme.colors.global.contentBackground};
    padding: ${theme.spacings.md};
    z-index: ${zIndices.modalBody};
  `
);
const StyledModalRoot = styled(MantineModal.Root)(
  ({ theme, $scrollInContent }) => css`
    --mantine-color-body: ${theme.colors.global.contentBackground};
    ${$scrollInContent && css`
      .mantine-Modal-content {
        display: flex;
        flex-direction: column;
      }

      .mantine-Modal-body {
        flex: 1;
        overflow: auto;
        display: flex;
        flex-direction: column;
      }
    `})
  `
);
const sizeForMantine = (size) => {
  switch (size) {
    case "sm":
    case "small":
      return "md";
    case "lg":
    case "large":
      return "xl";
    case "xl":
    case "xlarge":
      return XLARGE_MODAL_WIDTH_PX;
    default:
      return "lg";
  }
};
const Modal = ({
  onHide,
  show = false,
  children,
  bsSize = void 0,
  backdrop = true,
  closable = true,
  fullScreen = false,
  scrollInContent = false,
  className = void 0,
  isConfirmDialog = false,
  rootProps = {}
}) => /* @__PURE__ */ React.createElement(
  StyledModalRoot,
  {
    $scrollInContent: scrollInContent,
    opened: show,
    onClose: onHide,
    size: sizeForMantine(bsSize),
    trapFocus: true,
    closeOnEscape: closable,
    fullScreen,
    className,
    ...rootProps || {}
  },
  backdrop && /* @__PURE__ */ React.createElement(ModalOverlay, { $isConfirmDialog: isConfirmDialog }),
  /* @__PURE__ */ React.createElement(ModalContent, { $isConfirmDialog: isConfirmDialog }, children)
);
Modal.Header = ({ children, showCloseButton = true }) => /* @__PURE__ */ React.createElement(MantineModal.Header, null, children, showCloseButton && /* @__PURE__ */ React.createElement(MantineModal.CloseButton, null));
Modal.Title = styled(MantineModal.Title)`
  font-size: ${({ theme }) => theme.fonts.size.h2};
`;
Modal.Body = MantineModal.Body;
Modal.Footer = StyledModalFooter;
export default Modal;
